// removed by extract-text-webpack-plugin
module.exports = {"root":"product-grid--root--3eO-OgZQ","no-results":"product-grid--no-results--1i1T1UCb","noResults":"product-grid--no-results--1i1T1UCb"};


//////////////////
// WEBPACK FOOTER
// ./components/product-grid/styles.css
// module id = ./components/product-grid/styles.css
// module chunks = 0